<template>
  <div>
    <a-modal :visible="isShow" title="付款" @ok="doPay" @cancel="handleClose" @finish="doPay">
      是否确认付款，付款费用将从余额中扣除,付款后可在账户信息中查看账户流水
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'BatchPay',
  model: {
    prop: 'isShow',
    event: 'hiddenPay'
  },
  props: {
    isShow: {
      type: Boolean,
      required: false,
      default: false
    },
    orderIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
    }
  },
  created() {

  },
  methods: {
    doPay () {
      var _this = this
      if (_this.orderIds.length === 0) {
        _this.$message.error('请至少选择一个订单')
        return
      }
      _this.$util.api("/order/third/pay", { ids: this.orderIds }, (res) => {
        if (res.code === 10000) {
          _this.$message.success(res.msg)
        } else {
          _this.$message.error(res.msg);
        }
        _this.handleClose()
        setTimeout(function (f) {
          _this.$emit("refreshData")
        },1000)
      });
    },
    handleClose () {
      this.$emit("hiddenPay",false)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/deal/third/components/BatchPay.vue